import { createContext } from 'react';

const CopiedContext = createContext({
  showCopied: [],
  setShowCopied: () => {},
});

export default CopiedContext;